import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { LT_ROUTE } from 'bl/loggers.bl';
import LINK from 'constants/link.const';
import { COGNITO_STATE, selectCognitoState } from 'utils/cognito.util';
import { fromAnyToJsonClone } from 'utils/converters/json.util';
import logger from 'utils/logger.util';

const CTAG = 'PrivateRoute';
const L = logger([CTAG, LT_ROUTE]);

const PrivateRouteSpinner = () => (
  <div data-bem="PrivateRouteSpinner" className="loading-wrap">
    <div data-bem="PrivateRouteSpinner__anim" className="loading-anim">
      <div data-bem="PrivateRouteSpinner__title" className="loading-title">
        <span data-bem="PrivateRouteSpinner__text">Logging in</span>
      </div>
    </div>
    <div data-bem="PrivateRouteSpinner__feedback" className="loading-feedback">
      Checking passwords
    </div>
  </div>
);

const PrivateRoute = ({ component: Component, componentToLoad, ...rest }) => {
  const cognitoState = useSelector(selectCognitoState);
  const info = { Component, componentToLoad, rest };
  L.debug('()', 'cognitoState:', cognitoState, 'info:', info, 'cloned info:', fromAnyToJsonClone(info));

  if (cognitoState === COGNITO_STATE.loading) {
    return <Route {...rest} render={PrivateRouteSpinner} />;
  }

  if (cognitoState === COGNITO_STATE.in || cognitoState === COGNITO_STATE.authenticated) {
    return <Route {...rest} render={(props) => <Component {...props} component={componentToLoad} />} />;
  }

  if (cognitoState === COGNITO_STATE.needConfirmation) {
    L.info('()', 'User is in state of', cognitoState, 'redirecting to', LINK.onboardingSms);
    return <Route {...rest} render={({ location }) => <Redirect to={{ pathname: LINK.onboardingSms, state: { from: location } }} />} />;
  }

  L.info('()', 'User is in state of', cognitoState, 'redirecting to', LINK.root);
  return <Route {...rest} render={({ location }) => <Redirect to={{ pathname: LINK.root, state: { from: location } }} />} />;
};

export default PrivateRoute;
